import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import useModalEffect from '../../hooks/useModalEffect';

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  useModalEffect(isOpen);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) onClose();
    };
    if (isOpen) document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  const modalSizeClass = { sm: 'modal-sm', md: 'modal-md', lg: 'modal-lg', xl: 'modal-xl' }[size] || 'modal-md';

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <div className="modal-backdrop fade show" onClick={onClose} style={{ zIndex: 1040 }} />
      <div
        className="modal fade show"
        style={{ display: 'block', zIndex: 1050 }}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalTitle"
        onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      >
        <div className={`modal-dialog ${modalSizeClass} modal-dialog-centered`} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalTitle">{title}</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
            </div>
            {children}
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default Modal;
